'use strict';

module.exports = {
  template: require('./cn-invite-form.html'),
  controller: require('./cn-invite-form.controller'),
  controllerAs: 'vm',

  bindings: {
    firstName: '@',
    lastName: '@',
    onReset: '&',
    onSubmit: '&',
    onChange: '&',
    modal: '<',
    title: '@',
    email: '@',
    transpire: '@',
    invited: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-invite-form/index.js
 ** module id = 77
 ** module chunks = 0
 **/